import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['textBox', 'trigger'];

  show() {
    const duration = 1000;

    this.textBoxTarget.style.transitionDuration = `${duration}ms`;
    this.textBoxTarget.style.height =
      this.textBoxTarget.scrollHeight + 2 + 'px';

    this.triggerTarget.parentNode.removeChild(this.triggerTarget);

    Siepomaga.timeout(duration, () => {
      this.textBoxTarget.style.height = 'auto';
    });
  }
}
